import { Category } from 'panel/category/redux/types'
import { Product } from 'panel/product/redux/types'
import { Partner } from 'panel/partner/redux/types'
import { AlertActionTypes } from 'util/modules/Alert/redux/types'
import { PaginationOpts } from 'util/types/index'

/**
* Data Types
*/
export type ProductSectionData = {
  id?: number,
  isActive?: boolean,
  exported?: boolean,
  preserveHigherPrice?: boolean,
  name?: string
}

export type ProductSectionItemData = {
  isActive: boolean,
  tag: string,
  unity: string,
  price: number,
}

/**
* Types
*/

export type PartnerProductType = 'LOCAL'|'GLOBAL'
export type PartnerProductExtraType = 'OPTIONAL'|'ADDITIONAL'

export type ProductSectionItem = {
  id: number,
  isActive: boolean,
  pProd: Partial<PartnerProduct>,
  sections: ProductSection[],
  min: number,
  max: number,
  price: number,
  alias?: string,
  name: string,
  picture: string,
  createdAt: string,
  updatedAt?: string
}

export type ProductSection = {
  id: number,
  order: number,
  isActive: boolean,
  preserveHigherPrice: boolean,
  name: string,
  min: number,
  max: number,
  sections: ProductSection[],
  items: ProductSectionItem[],
  createdAt: string,
  updatedAt?: string
}

export interface PartnerProduct {
  id: number,
  isActive: boolean,
  isTempInactive: string,
  order: number,
  cashback: number,
  basePrice: number,
  lowestPrice: number,
  type: PartnerProductType,
  sections: ProductSection[],
  partner: Partial<Partner>,
  product: Product,
  createdAt: string,
  updatedAt: string
}

/**
* State Type
*/

export interface PartnerProductState {
  readonly product?: PartnerProduct
  readonly products: { items: PartnerProduct[], pagination?: PaginationOpts }
  readonly exportedSection: ProductSection[]
}

/**
* Action Enum Types
*/

export enum PartnerProductTypes {
  PARTNER_PRODUCT_ADD = 'PARTNER/PRODUCT/ADD',
  PARTNER_PRODUCT_UPDATE = 'PARTNER/PRODUCT/UPDATE',
  PARTNER_PRODUCT_DELETE = 'PARTNER/PRODUCT/DELETE',
  PARTNER_PRODUCT_GET = 'PARTNER/PRODUCT/GET',
  PARTNER_PRODUCT_GET_LIST = 'PARTNER/PRODUCT/GET/LIST',
  PARTNER_PRODUCT_SET_IS_ACTIVE = 'PARTNER/PRODUCT/SET/IS_ACTIVE',

  PARTNER_PRODUCT_ADD_EXTRA = 'PARTNER/PRODUCT/ADD/EXTRA',
  PARTNER_PRODUCT_DEL_EXTRA = 'PARTNER/PRODUCT/DEL/EXTRA',
  PARTNER_PRODUCT_PUT_EXTRA = 'PARTNER/PRODUCT/PUT/EXTRA',

  PARTNER_PRODUCT_SECTION_CREATE = 'PARTNER/PRODUCT/SECTION/CREATE',
  PARTNER_PRODUCT_SECTION_UPDATE = 'PARTNER/PRODUCT/SECTION/UPDATE',
  PARTNER_PRODUCT_SECTION_DELETE = 'PARTNER/PRODUCT/SECTION/DELETE',
  PARTNER_PRODUCT_SECTION_IS_ACTIVE = 'PARTNER/PRODUCT/SECTION/IS_ACTIVE',
  PARTNER_PRODUCT_SECTION_EXPORTED = 'PARTNER/PRODUCT/SECTION/EXPORTED',

  PARTNER_PRODUCT_SECTION_ITEM_CREATE = 'PARTNER/PRODUCT/SECTION_ITEM/CREATE',
  PARTNER_PRODUCT_SECTION_ITEM_UPDATE = 'PARTNER/PRODUCT/SECTION_ITEM/UPDATE',
  PARTNER_PRODUCT_SECTION_ITEM_DELETE = 'PARTNER/PRODUCT/SECTION_ITEM/DELETE',
}

/**
* Action Types
*/
interface AddPartnerProduct {
  type: PartnerProductTypes.PARTNER_PRODUCT_ADD,
  payload: PartnerProduct
}

interface UpdatePartnerProduct {
  type: PartnerProductTypes.PARTNER_PRODUCT_UPDATE,
  payload: PartnerProduct
}

interface GetPartnerProduct {
  type: PartnerProductTypes.PARTNER_PRODUCT_GET,
  payload: PartnerProduct
}

interface GetPartnerProductList {
  type: PartnerProductTypes.PARTNER_PRODUCT_GET_LIST,
  payload: PartnerProduct[]
  pagination?: PaginationOpts
}

interface DeletePartnerProduct {
  type: PartnerProductTypes.PARTNER_PRODUCT_DELETE,
  payload: number
}

interface PartnerProductIsActive {
  type: PartnerProductTypes.PARTNER_PRODUCT_SET_IS_ACTIVE,
  payload: boolean
}

interface PartnerProductSectionCreate {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_CREATE,
  payload: ProductSection
}

interface PartnerProductSectionUpdate {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_UPDATE,
  payload: ProductSection
}

interface PartnerProductSectionDelete {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_DELETE,
  payload: number
}

interface PartnerProductSectionIsActive {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_IS_ACTIVE,
  payload: number,
  isActive: boolean
}

interface PartnerProductSectionItemCreate {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_ITEM_CREATE,
  payload: ProductSectionItem,
  typeId: number
}

interface PartnerProductSectionItemUpdate {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_ITEM_UPDATE,
  payload: ProductSectionItem,
  typeId: number
}

interface PartnerProductSectionItemDelete {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_ITEM_DELETE,
  payload: number,
  typeId: number
}

interface ExportedSectionListAction {
  type: PartnerProductTypes.PARTNER_PRODUCT_SECTION_EXPORTED,
  payload: ProductSection[]
}

export type PartnerProductActionTypes = (
  AlertActionTypes | AddPartnerProduct | GetPartnerProduct | GetPartnerProductList |
  DeletePartnerProduct | UpdatePartnerProduct | PartnerProductIsActive |
  PartnerProductSectionCreate | PartnerProductSectionUpdate | PartnerProductSectionDelete |
  PartnerProductSectionIsActive | ExportedSectionListAction |
  PartnerProductSectionItemCreate | PartnerProductSectionItemUpdate | PartnerProductSectionItemDelete
)
